import Navbar from '../components/Navbar';
import Banner from '../components/Banner';
import Slider from "../components/Slider/Slider";
import ProcessFlow from '../components/ProcessFlow';
//import FeaturesSection from '../components/FeaturesSection';
import Testimonials from '../components/Testimonials';
import { slidesData } from "../components/Slider/SlidesData"
import CallToAction from '../components/CallToAction';
import Footer from '../components/Footer';
import ServiceCards from '../components/ServiceCards';
import CallToActionSecond from '../components/CallToActionSecond';
import DoorstepPickup from '../components/DoorstepPickup';

import FAQHomePage from '../components/FAQHomePage';

import BranchesSection from '../components/BranchesSection';

const Home = () => {
  return (
    <div className="font-sans">
     
      <Navbar />
      <Slider slides={slidesData} />
      <Banner />
      
      <ProcessFlow /> 
      <ServiceCards />  {/* ✅ Added here */}
      <DoorstepPickup />
      <Testimonials />
      <CallToAction />
      <CallToActionSecond />
      <FAQHomePage/> 
      <BranchesSection/>     
      <Footer />   {/* ✅ Added Footer */}
    </div>
  );
};

export default Home;